import { Modal } from "@ab.uitools/ui-library/components/Modal";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isDeleteModalOpen: boolean;
  onSubmit: () => void;
  setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const DeleteBeneficiaryModal = ({
  isDeleteModalOpen,
  onSubmit,
  setIsDeleteModalOpen,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      onSubmit={onSubmit}
      buttonProps={{
        confirm: {
          buttonText: t("general.delete"),
          buttonActionType: "submit",
          formId: "",
          type: "danger",
        },
        cancel: { buttonText: t("general.cancel") },
      }}
      titleProps={{
        title: t("transfer.group.deleteBeneficiaryModal.title"),
        size: "large"
      }}
    >
    </Modal>
  );
};
